import { useEffect, useState } from "react";
import { Link, useOutletContext } from "react-router-dom";

const ServiceDetails = () => {


  const { bookingData, setBookingData, serviceData } = useOutletContext();

  const [services, setServices] = useState([]);
  const [tempServiceId, setTempServiceId] = useState("");

  useEffect(() => {
    const arr = Array.isArray(serviceData) ? serviceData : [];
    setServices(arr);

    if (arr.length > 0) {
      setTempServiceId((prev) => prev || arr[0].serviceId);
    } else {
      setTempServiceId("");
    }

  }, [serviceData]);

  const selectedServices = bookingData?.selectedServices || [];
  const selectedServiceObjects = selectedServices
    .map((id) => services.find((s) => s.id === id))
    .filter(Boolean);





  const addService = () => {
    if (!tempServiceId) return;

    setBookingData((prev) => {
      const current = prev?.selectedServices || [];
      if (current.includes(tempServiceId)) return prev;

      return {
        ...prev,
        selectedServices: [...current, tempServiceId],
      };
    });
  };

  const removeService = (serviceId) => {
    setBookingData((prev) => ({
      ...prev,
      selectedServices: (prev?.selectedServices || []).filter(
        (id) => id !== serviceId
      ),
    }));

  };

  const isAlreadySelected = selectedServices.includes(tempServiceId);

  return (
    <section className="rounded-2xl bg-white p-6 shadow-sm">
      <h2 className="text-xl font-semibold">Service Details</h2>

      <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
        <select
          className="input border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
          value={tempServiceId}
          onChange={(e) => setTempServiceId(e.target.value)}
        >
          <option value="" disabled>
            Select a service
          </option>
          {services.map((service) => (
            <option key={service.id} value={service.id} disabled={service.id === "xx"}>

              {service.name} - {service.time_taken} mins
            </option>
          ))}
        </select>

        <button
          type="button"
          onClick={addService}
          disabled={!tempServiceId || isAlreadySelected}
          className="cursor-pointer rounded-md bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isAlreadySelected ? "Added" : "Add"}
        </button>
      </div>

      <div className="mt-6">
        <p className="text-sm font-medium text-gray-700">Selected Services</p>

        {selectedServiceObjects.length === 0 ? (
          <p className="mt-2 text-sm text-gray-500">No services added yet.</p>
        ) : (
          <div className="mt-3 grid gap-3 sm:grid-cols-2">
            {selectedServiceObjects.map((service) => (
              <div
                key={service.id}
                className="flex items-center justify-between rounded-lg border border-gray-200 bg-white p-3 shadow-sm"
              >
                <div>
                  <p className="text-sm font-semibold text-gray-800">
                    {service.name}
                  </p>
                  <p className="text-xs text-gray-500">
                    {service.time_taken} mins
                  </p>
                </div>

                <button
                  type="button"
                  onClick={() => removeService(service.id)}

                  className="cursor-pointer rounded-full px-2 text-sm font-bold text-gray-500 hover:text-red-600"
                  aria-label="Remove service"
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="mt-8 flex justify-between">
        <Link
          to="/appointments"
          className="rounded-xl border px-6 py-3 text-sm font-semibold"
        >
          ← Back
        </Link>



        <Link
          to="/appointments/date"
          className={`rounded-xl px-6 py-3 text-sm font-semibold text-white 
              ${bookingData.selectedServices.length < 1 ? "bg-gray-400 cursor-not-allowed pointer-events-none": "bg-blue-600  hover:bg-blue-500" }    `}

          disabled={(bookingData.selectedServices.length < 1)}
        >
          Select Date →
        </Link>
      </div>
    </section>
  );
};

export default ServiceDetails;
